<popup-header [dialogRef]="dialogRef" icon="devices" [text]="getDialogTitle()"></popup-header>
<div class="add-program-dialog" id="add-program-dialog">
  <form [formGroup]="addProgramForm">
    <ul class="nav nav-tabs" id="add-program-tabs">
      <li class="nav-item">
        <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#details-tab" type="button" role="tab">
          Details
          @if (isTabDetailsInvalid()) {
            <span
              class="material-icons-outlined color_red exclamation-point"
              aria-hidden="true"
              color="accent"
              style="vertical-align: middle"
            matTooltip="Missing required fields">priority_high</span>
          }
        </button>
      </li>
      <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#contacts-tab" type="button" role="tab">
          Contacts
          @if (isTabContactsInvalid()) {
            <span
              class="material-icons-outlined color_red exclamation-point"
              aria-hidden="true"
              color="accent"
              style="vertical-align: middle"
            matTooltip="Missing required fields">priority_high</span>
          }
        </button>
      </li>
      <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#workstreams-tab" type="button" role="tab">
          Workstreams
          @if (isTabWorkstreamsInvalid()) {
            <span
              class="material-icons-outlined color_red exclamation-point"
              aria-hidden="true"
              color="accent"
              style="vertical-align: middle"
            matTooltip="Missing required fields">priority_high</span>
          }
        </button>
      </li>
      @if (programType === 'single') {
        <li class="nav-item">
          <button class="nav-link" data-bs-toggle="tab" data-bs-target="#gates-tab" type="button" role="tab">
            Deployment Gates
            @if (isTabGatesInvalid()) {
              <span
                class="material-icons-outlined color_red exclamation-point"
                aria-hidden="true"
                color="accent"
                style="vertical-align: middle"
              matTooltip="Missing required fields">priority_high</span>
            }
          </button>
        </li>
      }
    </ul>
    <div class="tab-content">
      <div class="tab-pane show active" id="details-tab" role="tabpanel">
        <div class="form-group">
          <label for="name">Name <span style="color: red">*</span></label>
          <input type="text" class="form-control" id="name" formControlName="name" data-cypress="program-name"  required />
          @if (addProgramForm.get('name')?.hasError('programNameExists')) {
            <div class="error-message">This program name already exists.</div>
          }
        </div>
        <div class="form-group">
          <label for="trigram">Trigram <span style="color: red">*</span></label>
          <input type="text" class="form-control" id="trigram" formControlName="trigram" required />
          @if (addProgramForm.get('trigram')?.hasError('pattern')) {
            <div class="error-message">
              Trigram must be 3 letters.
            </div>
          }
          @if (addProgramForm.get('trigram')?.hasError('programTrigramExists')) {
            <div class="error-message">
              This program trigram already exists.
            </div>
          }
        </div>
        @if (programType === 'single') {
          <div class="form-group">
            <label for="selectedProduct">Product <span style="color: red">*</span></label>
            <ng-select [items]="availableProducts" bindLabel="name" bindValue="idFormatted" formControlName="selectedProduct" placeholder="Select a product"></ng-select>
          </div>
        }
        <div class="form-group">
          <label for="ambition">Ambition</label>
          <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
          <ngx-editor
            class="ngx-editor"
            [editor]="editor"
            [disabled]="false"
            [placeholder]="'Add an ambition'"
            [(ngModel)]="ambition"
            [ngModelOptions]="{standalone: true}">
          </ngx-editor>
        </div>
        <div class="form-group">
          <label for="branches">Branch</label>
          <ng-select class="select-control-multiple" [items]="branches" formControlName="branches" [multiple]="true" placeholder="Branch"></ng-select>
        </div>
        <div class="form-group">
          <label for="entityOwner">Entity Owner</label>
          <ng-select [items]="entityOwnerOptions" bindLabel="name" bindValue="id" formControlName="entityOwnerId" placeholder="Entity Owner"></ng-select>
        </div>
        <div class="form-group">
          <label for="partnerCompany">Partner Company</label>
          <ng-select [items]="partnerCompanies" formControlName="partnerCompany" placeholder="Partner Company"></ng-select>
        </div>
        <div class="form-group">
          <label for="family">Family</label>
          <ng-select [items]="familyOptions" formControlName="family" placeholder="Family"></ng-select>
        </div>
        <div class="form-group">
          <label for="faitMarquantName">Corresponding Fait Marquant Name</label>
          <input type="text" class="form-control" id="faitMarquantName" formControlName="faitMarquantName" placeholder="Enter corresponding Fait Marquant Name" />
        </div>
        <div class="progress-panel">
          <div class="form-group">
            <h4>Progress Mode</h4>
            <div class="segmented-control-container">
              <button type="button" class="segmented-control-item"
                [ngClass]="{selected: addProgramForm.get('progressMode').value === 'auto'}"
                (click)="setParentProgressMode('auto')" data-cypress="program-progress-mode-auto">
                Auto
                <span class="material-icons-outlined progress-mode-help-icon"
                  [matTooltip]="globalProgressModeHelp.auto"
                  matTooltipClass="multiline-mat-tooltip"
                  matTooltipPosition="below"
                aria-hidden="true">info</span>
              </button>
              <button type="button" class="segmented-control-item"
                [ngClass]="{selected: addProgramForm.get('progressMode').value === 'manual'}"
                (click)="setParentProgressMode('manual')">
                Manual
                <span class="material-icons-outlined progress-mode-help-icon"
                  [matTooltip]="globalProgressModeHelp.manual"
                  matTooltipClass="multiline-mat-tooltip"
                  matTooltipPosition="below"
                aria-hidden="true">info</span>
              </button>
              <button type="button" class="segmented-control-item"
                [ngClass]="{selected: addProgramForm.get('progressMode').value === 'weight-based'}"
                (click)="setParentProgressMode('weight-based')" data-cypress="program-progress-mode-weight-based">
                Weight-based
                <span class="material-icons-outlined progress-mode-help-icon"
                  [matTooltip]="globalProgressModeHelp['weight-based']"
                  matTooltipClass="multiline-mat-tooltip"
                  matTooltipPosition="below"
                aria-hidden="true">info</span>
              </button>
            </div>
          </div>

          @if (addProgramForm.get('progressMode').value === 'manual') {
            <div class="form-group">
              <label for="progress">Progress (%) <span style="color: red">*</span></label>
              <input id="progress" type="number" class="form-control" min="0" max="100" formControlName="progress" data-cypress="program-progress-input" />
            </div>
          }

          @if (addProgramForm.get('progressMode').value === 'weight-based') {
            <div formArrayName="workstreams" style="margin-top: 12px;">
              <label for="workstreams" style="margin-bottom: 8px;">Workstreams Weights</label>
              @if (workstreams.length === 0) {
                <p class="info-section">
                  <span class="material-icons-outlined" aria-hidden="true">info</span>
                  <span>This program has no workstream yet. Progress will be calculated once workstreams are added.</span>
                </p>
              }
              @for (workstream of workstreams.controls; track workstream; let i = $index) {
                <div [formGroupName]="i" style="margin-bottom: 8px;">
                  <label class="visually-hidden" for="workstreamWeight">{{ workstream.value.name }}</label>
                  {{ workstream.value.name }} : <input id="workstreamWeight" type="number" class="form-control weight-input" min="0" max="100" formControlName="weight" data-cypress="program-workstream-weight-input" />
                </div>
              }
              @if (workstreams.length > 0 && getTotalWorkstreamWeight() != 100) {
                <div class="mt-2">
                  <span class="color_red">Total weight must be 100%. Current: {{ getTotalWorkstreamWeight() }}%</span>
                </div>
              }
            </div>
          }
        </div>
      </div>
      <div class="tab-pane" id="contacts-tab" role="tabpanel">
        <div formArrayName="contacts">
          @for (role of CONTACTS_LIST; track role) {
            <div class="role-section">
              @if (noFteContactRoles.includes(role)) {
                <div>
                  <div class="contact-container form-group">
                    <label for="role-{{role}}" class="role-label">{{ role }}</label>
                    <app-user-autocomplete
                      class="user-autocomplete"
                      [placeholder]="role"
                      [multiple]="true"
                      [clearable]="true"
                      (userSelected)="onMultiUsersSelected($event, role)"
                      [initialSelectedUsers]="getUsersForRole(role)">
                    </app-user-autocomplete>
                  </div>
                </div>
              }
              <!-- Template for single user roles with FTE -->
              @if (!noFteContactRoles.includes(role)) {
                <div>
                  @for (contactControl of getContactsByRole(role); track contactControl; let i = $index) {
                    <div [formGroup]="contactControl" class="contact-row">
                      <div class="contact-container form-group">
                        <label class="role-label" [for]="'role-input-' + role + i">
                          {{ role }} @if (role === 'Program Director') {
                          <span style="color: red">*</span>
                        }
                      </label>
                      <app-user-autocomplete
                        class="user-autocomplete"
                        [placeholder]="role"
                        [multiple]="false"
                        (userSelected)="onSingleUserSelected($event[0], contactControl)"
                        [initialSelectedUsers]="contactControl.get('user').value ? [contactControl.get('user').value] : []">
                      </app-user-autocomplete>
                    </div>
                    <div class="fte-group form-group">
                      <label [for]="'fte-input-' + role + i">FTE @if (contactControl.get('user').value) {
                        <span style="color: red">*</span>
                      }</label>
                      <div class="fte-buttons-container">
                        <input
                          [id]="'fte-input-' + role + i"
                          type="number"
                          class="form-control fte-input"
                          placeholder="50%"
                          formControlName="fte"
                          min="0"
                          max="100"
                          step="50" />
                          @if (getContactsByRole(role).length > 1) {
                            <button
                              class="btn btn-circle btn-tertiary"
                              (click)="removeContact(contacts.controls.indexOf(contactControl))"
                              >
                              <span class="material-icons-outlined" aria-hidden="true">remove_circle_outline</span>
                            </button>
                          }
                          @if (!singleContactRoles.includes(role)) {
                            <button class="btn btn-circle btn-tertiary" (click)="addContact(role)">
                              <span class="material-icons-outlined" aria-hidden="true">add_circle_outline</span>
                            </button>
                          }
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
      <div class="tab-pane" id="workstreams-tab" role="tabpanel">
        <div class="p-3">
          <div formArrayName="workstreams">
            @for (workstream of workstreams.controls; track workstream; let i = $index) {
              <div [formGroupName]="i" class="mb-3 workstream-container">
                <div class="workstream-header" (click)="toggleWorkstream(i)" (keydown)="toggleWorkstream(i)">
                  <span class="workstream-title">
                    {{ workstreams.at(i).get('name').value || 'New Workstream' }}
                  </span>
                  <div class="workstream-actions">
                    <span [matTooltip]="workstream.value.productIds?.length > 0 || workstream.value.hasRoadmapGroups ? 'This workstream cannot be removed as it has linked products or roadmap groups. Please remove products and groups before deleting the workstream.' : null">
                      @if (workstreams.length > 1) {
                        <button
                          [disabled]="workstream.value.productIds?.length > 0 || workstream.value.hasRoadmapGroups"
                          class="btn btn-circle btn-tertiary"
                          (click)="removeWorkstream(i); $event.stopPropagation()">
                          <span class="material-icons-outlined" aria-hidden="true" data-cypress="delete-workstream">delete</span>
                        </button>
                      }
                    </span>
                    <span class="material-icons">
                      {{ isWorkstreamOpen(i) ? "expand_less" : "expand_more" }}
                    </span>
                  </div>
                </div>
                @if (isWorkstreamOpen(i)) {
                  <div class="workstream-content">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="workstreamName{{ i }}">Name <span style="color: red">*</span></label>
                          <input type="text" id="workstreamName{{ i }}" formControlName="name" data-cypress="workstream-name" class="form-control">
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="workstreamDescription{{ i }}">Description <span style="color: red">*</span></label>
                      <textarea id="workstreamDescription{{ i }}" formControlName="description" class="form-control" rows="3"></textarea>
                    </div>
                    <div class="row">
                      <div class="col-md-8">
                        <div class="form-group">
                          <label for="workstreamManager{{ i }}">Manager <span style="color: red">*</span></label>
                          <app-user-autocomplete
                            class="user-autocomplete"
                            [placeholder]="'Manager'"
                            [multiple]="false"
                            (userSelected)="onWorkstreamManagerSelected($event, i)"
                            [initialSelectedUsers]="workstreams.at(i).get('manager').value ? [workstreams.at(i).get('manager').value] : []">
                          </app-user-autocomplete>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label [for]="'fte-input-' + i">FTE @if (workstreams.at(i).get('manager').value) {
                            <span style="color: red">*</span>
                          }</label>
                          <input [id]="'fte-input-' + i" type="number" class="form-control fte-input" placeholder="50%" formControlName="managerFte" min="0" max="100" step="50" />
                        </div>
                      </div>
                    </div>
                    @if (programType === 'multi') {
                      <div class="form-group">
                        <label for="workstreamProducts{{ i }}">Products</label>
                        <ng-select  class="select-control-multiple" [items]="availableProductsForWorkstream" bindLabel="name" bindValue="id" id="workstreamProducts{{ i }}"
                          formControlName="productIds" [multiple]="true"
                          (ngModelChange)="onWorkstreamProductsChanged($event, i)">
                        </ng-select>
                      </div>
                    }
                    @if (programType === 'multi') {
                      <div class="form-group">
                        <label for="workstreamEnablerItems{{ i }}">Enabler Items</label>
                        <ng-select class="select-control-multiple" [items]="availableEnablerItems"
                          bindLabel="name" bindValue="idFormatted"
                          id="workstreamEnablerItems{{ i }}"
                          formControlName="enablerItemIds" [multiple]="true"
                          placeholder="Select Enabler Items"
                          (ngModelChange)="onWorkstreamItemsChanged($event, i)">
                        </ng-select>
                      </div>
                    }
                    <div class="progress-panel">
                      <div class="form-group">
                        <h4>Progress Mode</h4>
                        <div class="segmented-control-container">
                          <button type="button" class="segmented-control-item"
                            [ngClass]="{selected: workstreams.at(i).get('progressMode').value === 'auto'}"
                            (click)="setProgressMode(i, 'auto')" data-cypress="workstream-progress-mode-auto">
                            Auto
                            <span class="material-icons-outlined progress-mode-help-icon"
                              [matTooltip]="workstreamProgressModeHelp.auto"
                              matTooltipClass="multiline-mat-tooltip"
                              matTooltipPosition="below"
                            aria-hidden="true">info</span>
                          </button>
                          <button type="button" class="segmented-control-item"
                            [ngClass]="{selected: workstreams.at(i).get('progressMode').value === 'manual'}"
                            (click)="setProgressMode(i, 'manual')">
                            Manual
                            <span class="material-icons-outlined progress-mode-help-icon"
                              [matTooltip]="workstreamProgressModeHelp.manual"
                              matTooltipClass="multiline-mat-tooltip"
                              matTooltipPosition="below"
                            aria-hidden="true">info</span>
                          </button>
                          <button type="button" class="segmented-control-item"
                            [ngClass]="{selected: workstreams.at(i).get('progressMode').value === 'weight-based'}"
                            (click)="setProgressMode(i, 'weight-based')" data-cypress="workstream-progress-mode-weight-based">
                            Weight-based
                            <span class="material-icons-outlined progress-mode-help-icon"
                              [matTooltip]="workstreamProgressModeHelp['weight-based']"
                              matTooltipClass="workstream-weighted-tooltip"
                              matTooltipPosition="above"
                            aria-hidden="true">info</span>
                          </button>
                        </div>
                      </div>
                      @if (workstreams.at(i).get('progressMode').value === 'manual') {
                        <div class="form-group">
                          <label for="progressWorkstream">Progress (%) <span style="color: red">*</span></label>
                          <input id="progressWorkstream" type="number" class="form-control" min="0" max="100" formControlName="progress" data-cypress="workstream-progress-input" />
                        </div>
                      }
                      @if (workstreams.at(i).get('progressMode').value === 'weight-based') {
                        <div formArrayName="groupWeights" style="margin-top: 12px;">
                          <label for="groupWeights" style="margin-bottom: 8px;">Roadmap Groups Weights</label>
                          @if (getGroupWeightsArray(i).length === 0) {
                            <p class="info-section">
                              <span class="material-icons-outlined" aria-hidden="true">info</span>
                              <span>This workstream has no roadmap group yet. Progress will be calculated once groups are added.</span>
                            </p>
                          }
                          @for (groupWeight of getGroupWeightsArray(i).controls; track groupWeight; let j = $index) {
                            <div [formGroupName]="j" style="margin-bottom: 8px;">
                              <label class="visually-hidden" for="groupWeight">Weight for {{ groupWeight.value.name }}</label>
                              {{ groupWeight.value.name }} : <input id="groupWeight" type="number" class="form-control weight-input" min="0" max="100" formControlName="weight" />
                            </div>
                          }
                          @if (getGroupWeightsArray(i).length > 0 && getTotalGroupWeight(i) != 100) {
                            <div class="mt-2">
                              <span class="color_red">Total weight must be 100%. Current: {{ getTotalGroupWeight(i) }}%</span>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
          <button type="button" class="btn btn-secondary" (click)="addWorkstream()">
            <span class="material-icons-outlined" aria-hidden="true">add_circle_outline</span> Add Workstream
          </button>
        </div>
      </div>
      @if (programType === 'single') {
        <div class="tab-pane" id="gates-tab" role="tabpanel">
          <div class="gates-section">
            <p class="info-section"><span class="material-icons-outlined" aria-hidden="true">info</span><span><b>Info :</b> Define and customize the key milestones of your deployment for each asset. Each milestone has a weight that reflects its contribution to the overall asset deployment progress. These weights are used to calculate progress indicators in the Deployment Progress.</span></p>
            <div id="gates-list">
              @for (gate of gates; track gate; let i = $index) {
                <div>
                  <div class="gate-row">
                    <div class="form-group gate-name">
                      <label for="gate-name-{{i}}" class="mb-1">Gate Name <span style="color: red">*</span></label>
                      <input [disabled]="i == gates.length - 1" id="gate-name-{{i}}" type="text" [(ngModel)]="gate.name" placeholder="Gate name" [ngModelOptions]="{standalone: true}" class="form-control gate-name-input" required />
                    </div>
                    <div class="form-group">
                      <label for="gate-weight-{{i}}" class="mb-1 mt-2">Weight (%) <span style="color: red">*</span></label>
                      <input [disabled]="i == gates.length - 1" id="gate-weight-{{i}}" type="number" [(ngModel)]="gate.weight" placeholder="Weight (%)" (ngModelChange)="onGateWeightChange()" [ngModelOptions]="{standalone: true}" class="form-control gate-weight-input" min="0" max="100" required />
                    </div>
                    <div [matTooltip]="gate.hasDeploymentGroups && gate.name != 'Full Value' && gate.id != null? 'There are deployment groups defined on this program and this gate. Please remove them if you want to delete the gate.' : null">
                      @if (gates.length > 1) {
                        <button
                          type="button"
                          class="btn btn-tertiary mt-2"
                          (click)="removeGate(i)"
                          [disabled]="gate.hasDeploymentGroups && gate.id != null"
                          [ngStyle]="i == gates.length - 1 ? {'visibility': 'hidden'} : {}">
                          <span class="material-icons-outlined" aria-hidden="true">delete</span>
                        </button>
                      }
                    </div>
                  </div>
                  @if (!gate.name || gate.name.trim() === '') {
                    <div style="color: red">Gate name is required.</div>
                  }
                  @if (gate.weight === null || gate.weight === undefined || gate.weight === '') {
                    <div style="color: red">Gate weight is required.</div>
                  }
                </div>
              }
            </div>
            <button type="button" class="btn btn-secondary mt-2" (click)="addGate()">
              <span class="material-icons-outlined" aria-hidden="true">add_circle_outline</span> Add Gate
            </button>
            @if (getTotalGateWeight() !== 100) {
              <div class="gate-weight-warning mt-2">
                <span class="color_red">Total gate weight must be 100%. Current: {{ getTotalGateWeight() }}%</span>
              </div>
            }
          </div>
        </div>
      }
    </div>
    <div class="form-actions">
      <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button>
      <span
        [matTooltip]="hasInvalidFullValueGate() ? 'You cannot add a gate named Full Value. Please rename or remove it.' : (programType === 'single' && getTotalGateWeight() !== 100 ? 'Total gate weight must be 100%' : (hasInvalidWorkstreamWeights() ? 'Total roadmap groups weight must be 100% for each workstream in auto mode' : (hasInvalidParentWorkstreamWeights() ? 'Total workstream weight must be 100%' : '')))"
        matTooltipPosition="above">
        <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="addProgramForm.invalid || (programType === 'single' && getTotalGateWeight() !== 100) || hasInvalidFullValueGate() || hasInvalidWorkstreamWeights() || hasInvalidParentWorkstreamWeights()" id="save-button">
          {{ data?.program?.id ? "Save & Close" : "Add Program" }}
        </button>
      </span>
    </div>
  </form>
</div>
